import isNumber from "./isNumber.js";
import isString from "./isString.js";
import { isPromise } from "./_internal/utils.js";
function sync(a, b) {
    if (isNumber(a) && isNumber(b)) {
        return a + b;
    }
    if (isString(a) && isString(b)) {
        return a + b;
    }
    throw new TypeError("'a' or 'b' must be type of number or string");
}
async function async(a, b) {
    return sync(await a, await b);
}
function add(a, b) {
    if (b === undefined) {
        return (b) => {
            return add(a, b);
        };
    }
    if (isPromise(a) || isPromise(b)) {
        return async(Promise.resolve(a), Promise.resolve(b));
    }
    return sync(a, b);
}
export default add;
//# sourceMappingURL=add.js.map